import getSymbolFromCurrency from "currency-symbol-map";

export default {
  install(app) {
    app.config.globalProperties.$currencySymbol = getSymbolFromCurrency;
    app.provide("$currencySymbol", getSymbolFromCurrency);
  },
};
